// extracted by mini-css-extract-plugin
export default {"cell":"FavoriteProductsEditCell_cell__+soYT","count":"FavoriteProductsEditCell_count__VDnEp"};